import GameStatesEnum from "@/states/GameStatesEnum";
import BaseState from '@state/BaseState'
import { Signals} from "@/Imports";
import Facade from "@/Facade";

export default class RoundStartState extends BaseState {

  begin() {
    Signals.socketClosed.add(this.onSocketClosed, this)
    Signals.forceRoundEnd.add(this.onForceRoundEnd, this)
    Facade.state = 'lift'
    //Facade.model.roundStart()

    setTimeout(() => {
      Facade.isPlaneStarted = true
      Facade.state = 'flight'
      Signals.roundStart.dispatch()
      Facade.model.roundStart()

    }, this.model.roundStartDelay)
  }

  onForceRoundEnd() {
    this.stateMachine.setState(GameStatesEnum.ROUND_END)
  }

  onSocketClosed() {
    this.stateMachine.setState(GameStatesEnum.RECONNECT_SOCKET)
  }

  cleanUp() {
    Signals.socketClosed.remove(this.onSocketClosed, this)
    Signals.forceRoundEnd.remove(this.onForceRoundEnd, this)
  }

}
